import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Outsourced} from "../Outsourced";
import {gsap} from "gsap";
import {OutsourcedCrashGameWinPresentation} from "./OutsourcedCrashGameWinPresentation";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class OutsourcedCrashGameIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        if (Outsourced.apiPlugin.bonusFeatures.notAllowedFeatures.some((feature) => feature.name == "CRASH_GAME")) {
            Outsourced.apiPlugin.betHandler.zeroBet({playCrashGame:0});
            flowStateController.finish();
            return;
        }

        const tl:gsap.core.Timeline = gsap.timeline();
        OutsourcedCrashGameWinPresentation.wasTotalWin = Outsourced.model.data.mode != GameMode.NORMAL;
        if (Outsourced.model.data.mode != "CRASH_GAME") {
            tl.add(Outsourced.apiPlugin.isReplay
                   ? Outsourced.transitionScreen.crashGame.replay()
                   : Outsourced.model.isGodModeDeluxe
                     ? Outsourced.transitionScreen.crashGame.enableFeatureBuy()
                     : Outsourced.transitionScreen.crashGame.enable());
            tl.add(Outsourced.soundPlayer.playLoopBased("slashGameAnythingElseLoop"), '<');
            tl.add(() => Outsourced.soundPlayer.fadeOutMusic());
        }
        if (Outsourced.model.isRestore && Outsourced.model.data.mode == "CRASH_GAME") {
            Outsourced.apiPlugin.betHandler.zeroBet({crashGameMultiplier:50000});
            Outsourced.transitionScreen.crashGame.restore();
        }
        if (Outsourced.apiPlugin.isReplay && Outsourced.model.data.mode == "CRASH_GAME") {
            Outsourced.apiPlugin.betHandler.zeroBet({crashGameMultiplier:Outsourced.model.data.nextPlayerInteraction?.crashGameMultiplier});
            Outsourced.transitionScreen.crashGame.restore();
        }
        tl.add(() => flowStateController.finish());
    }
}